export default "__VITE_ASSET__D6Rqvbe1__"